/* global window */
export default config => ({
  handle(status) {
    if (status === 401) {
      // login redirect
      window.location.href = config.loginUrl;
    }
  },
});



/** WEBPACK FOOTER **
 ** ./src/handler.js
 **/